/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import { service } from '@ember/service';
import HotelStrategyStrategyDetailBaseController from 'lumen/controllers/hotel/strategy/strategy-detail-base';
import {
  COLUMN_PROPERTIES,
  TYPE_ID_POSITION,
} from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyPositionController extends HotelStrategyStrategyDetailBaseController {
  @service('hotel-and-market') hotelAndMarketService;
  @service rsSelections;

  @computed(
    'hasRSData',
    'rsSelections.baseBaseRatesPerHotelInfo',
    'selectedCompetitors',
  )
  get positionDataPerHotelInfo() {
    const positionDataPerHotelInfo = new Map();

    if (this.hasRSData) {
      // Initialize Map
      this.selectedCompetitors.forEach((hotelinfo) => {
        const baserate = this.rsSelections.baseBaseRatesPerHotelInfo.get(
          hotelinfo.id,
        );

        // Mimic the structure of the other detail views (with grouped columns) so all functionality can be reused (e.g. sort)
        const tableColumns = {
          [COLUMN_PROPERTIES.HOTELINFO]: {
            id: hotelinfo.id,
            formattedValue: hotelinfo.name,
            isOwnHotelInfo:
              this.hotelAndMarketService.isOwnHotelInfo(hotelinfo),
          },
          [TYPE_ID_POSITION]: {
            [COLUMN_PROPERTIES.RATE]: {
              value: baserate.rate,
              formattedValue: baserate.formattedBaseRate,
              baserate,
              hasNoData: baserate.hasNoBaseRate,
              hasNoTooltip: true, // Disable tooltips in the position modal (columns are wider)
            },
            [COLUMN_PROPERTIES.ROOM_NAME]: {
              value: baserate.formattedRoomname,
              formattedValue: baserate.formattedRoomname,
              hasNoData: baserate.hasNoBaseRate,
              hasNoTooltip: true, // Disable tooltips in the position modal (columns are wider)
            },
          },
        };

        positionDataPerHotelInfo.set(hotelinfo.id, tableColumns);
      });
    }

    return positionDataPerHotelInfo;
  }
}
